// import React, { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Chip,
//   TablePagination,
//   CircularProgress,
//   IconButton,
//   Menu,
//   MenuItem,
//   ListItemIcon,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Tabs,
//   Tab,
// } from "@mui/material";

// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";

// import { BASE_URL } from "../../../services/configUrls";
// import InfoOutlined from "@mui/icons-material/InfoOutlined";
// import { Tooltip } from "@mui/material";

// /* ---------------- CONSTANTS ---------------- */
// const STATUS_TABS = ["Pending", "Accepted", "Booked", "Cancelled"];
// const TAB_INFO = {
//   Pending:
//     "FDP requests submitted by institutes and awaiting approval or cancellation.",
//   Accepted:
//     "Approved FDP requests that are ready to be booked into a slot.",
//   Booked:
//     "FDPs that are confirmed, scheduled, or already completed.",
//   Cancelled:
//     "FDP requests that were cancelled and will not be processed further.",
// };

// const statusColor = {
//   Pending: "warning",
//   Accepted: "success",
//   Booked: "info",
//   Cancelled: "error",
//   Completed: "default",
// };

// const FDPInterestsTable = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [activeTab, setActiveTab] = useState("Pending");

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedRow, setSelectedRow] = useState(null);

//   const [membershipOpen, setMembershipOpen] = useState(false);
//   const [selectedMembership, setSelectedMembership] = useState(null);

//   /* ---------------- FETCH ---------------- */
//   const fetchInterests = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${BASE_URL}/event/all-institute-interests`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );
//       setData(res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch FDP interests", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchInterests();
//   }, []);

//   /* ---------------- FILTER BY TAB ---------------- */
//   const filteredData = useMemo(() => {
//   if (activeTab === "Booked") {
//     return data.filter(
//       (row) => row.status === "Booked" || row.status === "Completed"
//     );
//   }
//   return data.filter((row) => row.status === activeTab);
// }, [data, activeTab]);

//   /* ---------------- ACTIONS ---------------- */
// const updateInterestStatus = async (interestId, status) => {
//   try {
//     await axios.put(
//       `${BASE_URL}/event/fdp-interest/status`,
//       { interest_id: interestId, status },
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       }
//     );
//     handleMenuClose();
//     fetchInterests();
//   } catch (e) {
//     alert(
//       e?.response?.data?.detail ||
//         e?.response?.data?.error ||
//         "Something went wrong"
//     );
//   }
// };

//   const handleMenuOpen = (event, row) => {
//     setAnchorEl(event.currentTarget);
//     setSelectedRow(row);
//   };

//   const handleMenuClose = () => {
//     setAnchorEl(null);
//     setSelectedRow(null);
//   };

//   /* ---------------- MEMBERSHIP ---------------- */
//   const handleMembershipOpen = (row) => {
//     setSelectedMembership(row);
//     setMembershipOpen(true);
//   };

//   const handleMembershipClose = () => {
//     setMembershipOpen(false);
//     setSelectedMembership(null);
//   };

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" py={6}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <>
//       {/* ---------------- STATUS TABS ---------------- */}
//       <Tabs
//   value={activeTab}
//   onChange={(_, value) => {
//     setActiveTab(value);
//     setPage(0);
//   }}
//   sx={{
//     mb: 2,
//     minHeight: 44,
//     "& .MuiTabs-indicator": {
//       height: 3,
//       borderRadius: 2,
//     },
//   }}
// >
//   {STATUS_TABS.map((tab) => (
//     <Tab
//       key={tab}
//       value={tab}
//       label={
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <Typography
//             component="span"
//             sx={{
//               fontSize: "0.80rem",
//               fontWeight: 500,
//               letterSpacing: "0.2px",
//             }}
//           >
//             {tab.toUpperCase()}
//           </Typography>

//           <Tooltip
//             title={TAB_INFO[tab]}
//             arrow
//             placement="top"
//           >
//             <InfoOutlined
//               fontSize="small"
//               onClick={(e) => e.stopPropagation()}
//               sx={{
//                 color: "text.secondary",
//                 cursor: "pointer",
//                 ml: 0.25,
//                 "&:hover": {
//                   color: "primary.main",
//                 },
//               }}
//             />
//           </Tooltip>
//         </Box>
//       }
//       sx={{
//         minHeight: 44,
//         px: 2,
//         textTransform: "none",
//         color: "text.secondary",
//         "&.Mui-selected": {
//           color: "primary.main",
//           fontWeight: 600,
//         },
//       }}
//     />
//   ))}
// </Tabs>

//       <Paper sx={{ borderRadius: 3, border: "1px solid #e5e7eb" }}>
//         <Table>
//           <TableHead>
//             <TableRow sx={{ backgroundColor: "#f8fafc" }}>
//               <TableCell><b>Domain</b></TableCell>
//               <TableCell><b>Institute</b></TableCell>
//               <TableCell><b>Date Range</b></TableCell>
//               <TableCell><b>Trainer</b></TableCell>
//               <TableCell><b>Status</b></TableCell>
//               <TableCell><b>Membership</b></TableCell>
//               <TableCell align="center"><b>Actions</b></TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {filteredData
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((row) => (
//                 <TableRow key={row.interest_id} hover>
//                   <TableCell>{row.domain_name}</TableCell>
//                   <TableCell>{row.institute_name}</TableCell>
//                   <TableCell>
//                     {formatDate(row.start_date)} – {formatDate(row.end_date)}
//                   </TableCell>

//                   <TableCell>
//                     <Typography fontWeight={500}>{row.trainer_name}</Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {row.trainer_email}
//                     </Typography>
//                   </TableCell>

//                   <TableCell>
//                     <Chip
//                       size="small"
//                       label={row.status}
//                       color={statusColor[row.status] || "default"}
//                     />
//                   </TableCell>

//                   <TableCell>
//                     {row.membership_name ? (
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         onClick={() => handleMembershipOpen(row)}
//                       >
//                         View
//                       </Button>
//                     ) : (
//                       "—"
//                     )}
//                   </TableCell>

//                   {/* ✅ ACTIONS ONLY FOR PENDING */}
//                   <TableCell align="center">
//                     <IconButton
//                       size="small"
//                       onClick={(e) => handleMenuOpen(e, row)}
//                       disabled={row.status !== "Pending"}
//                     >
//                       <MoreVertIcon fontSize="small" />
//                     </IconButton>
//                   </TableCell>
//                 </TableRow>
//               ))}

// {filteredData.length === 0 && (
//   <TableRow>
//     <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
//       No records found
//     </TableCell>
//   </TableRow>
// )}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={filteredData.length}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={(_, newPage) => setPage(newPage)}
//           onRowsPerPageChange={(e) => {
//             setRowsPerPage(parseInt(e.target.value, 10));
//             setPage(0);
//           }}
//         />
//       </Paper>

//       {/* ---------------- ACTION MENU ---------------- */}
//       <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
//         {selectedRow?.status === "Pending" && (
//           <>
//             <MenuItem
//               onClick={() =>
//                 updateInterestStatus(selectedRow.interest_id, 1)
//               }
//             >
//               <ListItemIcon>
//                 <CheckCircleIcon color="success" fontSize="small" />
//               </ListItemIcon>
//               <ListItemText primary="Accept" />
//             </MenuItem>

//             <MenuItem
//               onClick={() =>
//                 updateInterestStatus(selectedRow.interest_id, 2)
//               }
//             >
//               <ListItemIcon>
//                 <CancelIcon color="error" fontSize="small" />
//               </ListItemIcon>
//               <ListItemText primary="Cancel" />
//             </MenuItem>
//           </>
//         )}
//       </Menu>

//       {/* ---------------- MEMBERSHIP DIALOG ---------------- */}
//     <Dialog open={membershipOpen} onClose={handleMembershipClose} PaperProps={{ sx: { borderRadius: 3, minWidth: 350, p: 2, }, }} > <DialogTitle sx={{ fontWeight: 700, fontSize: "1.2rem" }}> Membership Details </DialogTitle> <DialogContent dividers> {selectedMembership ? ( <> <Box sx={{ mb: 2, p: 2, border: "1px solid #e0e0e0", borderRadius: 2, bgcolor: "#f9fafb", }} > <Typography fontWeight={600} variant="subtitle1" gutterBottom> {selectedMembership.membership_name} </Typography> {selectedMembership.fdp_limits ? ( <> <Box sx={{ mt: 1 }}> <Typography variant="body2" color="text.secondary"> Host Limit: </Typography> <Typography fontWeight={500}> {selectedMembership.fdp_limits.host_limit.used} /{" "} {selectedMembership.fdp_limits.host_limit.total} (Left:{" "} {selectedMembership.fdp_limits.host_limit.left}) </Typography> </Box> <Box sx={{ mt: 1 }}> <Typography variant="body2" color="text.secondary"> Educators Limit: </Typography> <Typography fontWeight={500}> {selectedMembership.fdp_limits.educators_limit.used} /{" "} {selectedMembership.fdp_limits.educators_limit.total} (Left:{" "} {selectedMembership.fdp_limits.educators_limit.left}) </Typography> </Box> </> ) : ( <Typography color="text.secondary">No FDP limits available</Typography> )} </Box> </> ) : ( <Typography color="text.secondary">No Membership</Typography> )} </DialogContent> <DialogActions> <Button onClick={handleMembershipClose} variant="contained" color="primary" sx={{ borderRadius: 2 }} > Close </Button> </DialogActions> </Dialog>

//     </>
//   );
// };

// export default FDPInterestsTable;
import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TablePagination,
  CircularProgress,
  Tabs,
  Tab,
  TextField,
  MenuItem,
  Tooltip,
  IconButton,
  Menu,
  ListItemIcon,
  ListItemText,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";

import InfoOutlined from "@mui/icons-material/InfoOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import BookmarkAddOutlinedIcon from "@mui/icons-material/BookmarkAddOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { BASE_URL } from "../../../services/configUrls";

/* ---------------- CONSTANTS ---------------- */
const STATUS_TABS = ["Pending", "Booked", "Cancelled"];

const statusColor = {
  Pending: "warning",
  "Payment Pending": "warning",
  Paid: "success",
  Accepted: "success",
  Booked: "info",
  Cancelled: "error",
  Completed: "default",
};

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const MAX_IMAGE_SIZE = 500 * 1024; // 500 KB

const INITIAL_COORDINATOR = {
  name: "",
  mobile: "",
  email: "",
  gender: "Male",
};

const INITIAL_COORDINATOR_ERROR = {
  name: "",
  mobile: "",
  email: "",
  gender: "",
};

/* ---------------- INITIAL STATES ---------------- */
const INITIAL_FORM = {
  edition_no: "",
  total_faculty_limit: "",
  students_limit: "",
  slot_type: "paid",
  is_paid: "free",
  trainer_id: "",
  coordinators: [{ ...INITIAL_COORDINATOR }],
};

const INITIAL_ERRORS = {
  edition_no: "",
  total_faculty_limit: "",
  students_limit: "",
  slot_type: "",
  image: "",
  trainer_id: "",
  coordinators: [{ ...INITIAL_COORDINATOR_ERROR }],
};

/* ============================================================
   VALIDATE HELPERS
   ============================================================ */
const validateEmail = (v) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "" : "Enter a valid email address.";

const validateMobile = (v) =>
  /^[6-9]\d{9}$/.test(v) ? "" : "Enter a valid 10-digit mobile number.";

/* ============================================================
   MAIN COMPONENT
   ============================================================ */
const FDPInterestsTable = ({ type = "fdp" }) => {
  const label = type === "techcamp" ? "Tech Camp" : "FDP";

  const TAB_INFO = {
    Pending: `${label} requests awaiting action.`,
    Booked: `Confirmed or completed ${label}s.`,
    Cancelled: `Cancelled ${label} requests.`,
  };
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("Pending");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  /* Filters */
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  /* Membership dialog */
  const [selectedMembership, setSelectedMembership] = useState(null);
  const [membershipOpen, setMembershipOpen] = useState(false);

  /* Action menu */
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);

  /* Cancel Dialog */
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelError, setCancelError] = useState("");
  const [cancelingRow, setCancelingRow] = useState(null);

  /* Book Slot dialog */
  const [bookDialogOpen, setBookDialogOpen] = useState(false);
  const [bookingRow, setBookingRow] = useState(null);
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState(INITIAL_ERRORS);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [bookLoading, setBookLoading] = useState(false);
  const [bookError, setBookError] = useState("");
  const imageInputRef = useRef(null);

  const [availableTrainers, setAvailableTrainers] = useState([]);
  const [loadingTrainers, setLoadingTrainers] = useState(false);

  const selectedTrainerObj = useMemo(() => {
    if (!form.trainer_id || !availableTrainers) return null;
    return availableTrainers.find(t => t.trainer_id.toString() === form.trainer_id.toString());
  }, [form.trainer_id, availableTrainers]);

  const displayTrainerName = selectedTrainerObj ? selectedTrainerObj.fullname : (bookingRow?.trainer_name || "");

  const fetchTrainers = async (interestId) => {
    try {
      setLoadingTrainers(true);
      const res = await axios.get(
        `${BASE_URL}/event/coordinator/interest-trainers?interest_id=${interestId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      const trainers = res.data.available_trainers || [];
      setAvailableTrainers(trainers);

      // If only 1 trainer available, auto-select it!
      if (trainers.length === 1) {
        setForm((prev) => ({
          ...prev,
          trainer_id: trainers[0].trainer_id.toString(),
        }));
      }
    } catch (err) {
      console.error("Failed to fetch interest trainers", err);
      setAvailableTrainers([]);
    } finally {
      setLoadingTrainers(false);
    }
  };

  /* ---------------- FETCH ---------------- */
  const fetchInterests = async () => {
    try {
      setLoading(true);
      const url =
        type === "techcamp"
          ? "/event/all-institute-interests-techcamp"
          : "/event/all-institute-interests";

      const res = await axios.get(`${BASE_URL}${url}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      // OLD CODE FOR PDF
      // const res = await axios.get(`${BASE_URL}/event/all-institute-interests`, {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      //   },
      // });
      setData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch FDP interests", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInterests();
  }, [type]);

  /* ---------------- CANCEL ---------------- */
  const openCancelDialog = (row) => {
    handleMenuClose();
    setCancelingRow(row);
    setCancelReason("");
    setCancelError("");
    setCancelDialogOpen(true);
  };

  const closeCancelDialog = () => {
    setCancelDialogOpen(false);
    setCancelingRow(null);
    setCancelReason("");
    setCancelError("");
  };

  const submitCancelInterest = async () => {
    if (!cancelReason.trim()) {
      setCancelError("Reason is required.");
      return;
    }

    try {
      setActionLoading(true);

      const isTc =
        type === "techcamp" ||
        cancelingRow?.event_type?.toLowerCase() === "tech_camp";
      const url = isTc
        ? "/event/fdp-interest/status-techcamp"
        : "/event/fdp-interest/status-fdp";

      await axios.put(
        `${BASE_URL}${url}`,
        { interest_id: cancelingRow.interest_id, status: 2, reason: cancelReason },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      closeCancelDialog();
      await fetchInterests();
    } catch (e) {
      setCancelError(
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        "Something went wrong",
      );
    } finally {
      setActionLoading(false);
    }
  };

  /* ---------------- APPROVE FOR PAYMENT (Tech Camp & FDP) ---------------- */
  const approveForPayment = async (interestId, rowEventType) => {
    try {
      setActionLoading(true);

      const isTc =
        type === "techcamp" ||
        rowEventType?.toLowerCase() === "tech_camp" ||
        menuRow?.event_type?.toLowerCase() === "tech_camp";
      const url = isTc
        ? "/event/fdp-interest/status-techcamp"
        : "/event/fdp-interest/status-fdp";

      await axios.put(
        `${BASE_URL}${url}`,
        { interest_id: interestId, status: 1 },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );

      handleMenuClose();
      await fetchInterests();
    } catch (e) {
      alert(
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        "Something went wrong",
      );
    } finally {
      setActionLoading(false);
    }
  };

  /* ---------------- MENU HANDLERS ---------------- */
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };

  /* ---------------- BOOK DIALOG HANDLERS ---------------- */
  const openBookDialog = (row) => {
    handleMenuClose();
    setBookingRow(row);
    // Initialize form with payment status from response if available
    const initialFormWithPayment = {
      ...INITIAL_FORM,
      coordinators: [{ ...INITIAL_COORDINATOR }],
    };
    if (row?.slot_type) {
      const st = row.slot_type.toLowerCase().trim();
      if (["paid", "csr", "coe"].includes(st)) {
        initialFormWithPayment.slot_type = st;
      }
    }
    if (row?.payment) {
      if (row.event_type?.toLowerCase() === "tech_camp") {
        const rowPayment = row.payment.toLowerCase();
        const rowStatus = row.status?.toLowerCase();
        if (rowPayment === "free" && rowStatus !== "paid") {
          initialFormWithPayment.is_paid = "free";
        } else if (rowPayment === "paid" && rowStatus !== "paid") {
          initialFormWithPayment.is_paid = "paid";
        } else if (rowPayment === "free" && rowStatus === "paid") {
          initialFormWithPayment.is_paid = "paid";
        } else {
          initialFormWithPayment.is_paid = rowPayment === "paid" ? "paid" : "free";
        }
      } else {
        initialFormWithPayment.is_paid = row.payment.toLowerCase() === "paid" ? "paid" : "free";
      }
    }
    setForm(initialFormWithPayment);
    setErrors({
      ...INITIAL_ERRORS,
      coordinators: [{ ...INITIAL_COORDINATOR_ERROR }],
    });
    setImageFile(null);
    setImagePreview(null);
    setBookError("");
    setBookDialogOpen(true);
    fetchTrainers(row.interest_id);
  };
  const closeBookDialog = () => {
    setBookDialogOpen(false);
    setBookingRow(null);
    setBookError("");
    setImagePreview(null);
    setAvailableTrainers([]);
  };

  /* ---- coordinator handlers ---- */
  const handleCoordinatorChange = (index, field, value) => {
    setForm((prev) => {
      const updated = [...prev.coordinators];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, coordinators: updated };
    });

    setErrors((prev) => {
      const updatedErrors = [...(prev.coordinators || [])];
      let fieldErr = "";
      if (field === "name") {
        fieldErr = !value?.trim() ? "Coordinator name is required." : "";
      } else if (field === "mobile") {
        fieldErr = validateMobile(value);
      } else if (field === "email") {
        fieldErr = validateEmail(value);
      } else if (field === "gender") {
        fieldErr = !value ? "Please select a gender." : "";
      }
      updatedErrors[index] = {
        ...(updatedErrors[index] || INITIAL_COORDINATOR_ERROR),
        [field]: fieldErr,
      };
      return { ...prev, coordinators: updatedErrors };
    });
  };

  const handleAddCoordinator = () => {
    if (form.coordinators.length >= 3) return;
    setForm((prev) => ({
      ...prev,
      coordinators: [...prev.coordinators, { ...INITIAL_COORDINATOR }],
    }));
    setErrors((prev) => ({
      ...prev,
      coordinators: [
        ...(prev.coordinators || []),
        { ...INITIAL_COORDINATOR_ERROR },
      ],
    }));
  };

  const handleRemoveCoordinator = (indexToRemove) => {
    if (form.coordinators.length <= 1) return;
    setForm((prev) => ({
      ...prev,
      coordinators: prev.coordinators.filter((_, idx) => idx !== indexToRemove),
    }));
    setErrors((prev) => ({
      ...prev,
      coordinators: (prev.coordinators || []).filter(
        (_, idx) => idx !== indexToRemove
      ),
    }));
  };

  const isTechCamp =
    type === "techcamp" ||
    bookingRow?.event_type?.toLowerCase() === "tech_camp" ||
    bookingRow?.event_type?.toLowerCase() === "techcamp";

  const isFdp =
    type === "fdp" ||
    bookingRow?.event_type?.toLowerCase() === "fdp" ||
    (!isTechCamp && (!bookingRow?.event_type || bookingRow?.event_type?.toLowerCase() !== "tech_camp"));

  /* ---- field-level validation on change ---- */
  const validateField = (name, value) => {
    switch (name) {
      case "trainer_id":
        return availableTrainers && availableTrainers.length > 0 && !value
          ? "Trainer assignment is required."
          : "";
      // case "edition_no":
      //   return !value || Number(value) < 1
      //     ? "Edition number is required and must be ≥ 1."
      //     : "";
      case "total_faculty_limit":
        if (isFdp)
          return !value || Number(value) < 1
            ? "Total faculty limit is required and must be ≥ 1."
            : "";
        return "";
      case "students_limit":
        if (isTechCamp)
          return !value || Number(value) < 1
            ? "Student limit is required and must be ≥ 1."
            : "";
        return "";
      case "slot_type":
        return !value ? "Slot type is required." : "";
      default:
        return "";
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  /* ---- image handler ---- */
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) {
      setErrors((prev) => ({
        ...prev,
        image: "Image must be less than 500 KB.",
      }));
      setImageFile(null);
      setImagePreview(null);
      e.target.value = "";
      return;
    }
    setErrors((prev) => ({ ...prev, image: "" }));
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  /* ---- full form validation on submit ---- */
  const validateAll = () => {
    const fields = [
      // "edition_no",
      "trainer_id",
      "slot_type",
      ...(isFdp ? ["total_faculty_limit"] : []),
      ...(isTechCamp ? ["students_limit"] : []),
    ];

    const newErrors = {
      ...INITIAL_ERRORS,
      coordinators: [],
    };
    let valid = true;

    fields.forEach((name) => {
      const err = validateField(name, form[name]);
      newErrors[name] = err;
      if (err) valid = false;
    });

    const coordsErrors = form.coordinators.map((c) => {
      const cErr = {
        name: !c.name?.trim() ? "Coordinator name is required." : "",
        mobile: validateMobile(c.mobile),
        email: validateEmail(c.email),
        gender: !c.gender ? "Please select a gender." : "",
      };
      if (cErr.name || cErr.mobile || cErr.email || cErr.gender) {
        valid = false;
      }
      return cErr;
    });
    newErrors.coordinators = coordsErrors;

    if (!imageFile) {
      newErrors.image = "Please upload the hosted institute logo.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleBookSubmit = async () => {
    setBookError("");
    if (!validateAll()) return;

    const fd = new FormData();
    fd.append("interest_id", bookingRow.interest_id);
    if (form.edition_no) {
      fd.append("edition_no", form.edition_no);
    }
    if (form.trainer_id) {
      fd.append("trainer_id", form.trainer_id);
    }

    if (isFdp) {
      if (form.total_faculty_limit) {
        fd.append("total_faculty_limit", form.total_faculty_limit);
      }
    }

    if (isTechCamp || form.students_limit) {
      if (form.students_limit) {
        fd.append("students_limit", form.students_limit);
      }
    }

    fd.append("slot_type", form.slot_type || "paid");

    const coordinatorsPayload = form.coordinators.map((c) => ({
      name: c.name.trim(),
      gender: c.gender,
      email: c.email.trim(),
      mobile: c.mobile.trim(),
    }));
    fd.append("coordinators", JSON.stringify(coordinatorsPayload));

    fd.append("is_paid", 1);
    if (imageFile) {
      fd.append("image", imageFile);
    }

    console.log("=== Book from Interest FormData ===");
    for (let [key, value] of fd.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      setBookLoading(true);
      const res = await axios.post(`${BASE_URL}/event/coordinator/book-from-interest`, fd, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      alert(`${res.data.message}`);
      closeBookDialog();
      await fetchInterests();
    } catch (e) {
      setBookError(
        e?.response?.data?.detail ||
        e?.response?.data?.error ||
        "Booking failed. Please try again.",
      );
    } finally {
      setBookLoading(false);
    }
  };

  /* ---------------- YEAR OPTIONS ---------------- */
  const yearOptions = useMemo(() => {
    const years = new Set();
    data.forEach((row) => {
      if (row.start_date) years.add(new Date(row.start_date).getFullYear());
    });
    return Array.from(years).sort((a, b) => b - a);
  }, [data]);

  /* ---------------- MEMBERSHIP DIALOG ---------------- */
  const openMembership = (row) => {
    setSelectedMembership({
      membership_name: row.membership_name,
      fdp_limits: row.fdp_limits,
    });
    setMembershipOpen(true);
  };
  const closeMembership = () => {
    setMembershipOpen(false);
    setSelectedMembership(null);
  };

  /* ---------------- FILTERS ---------------- */
  const resetFilters = () => {
    setSearch("");
    setMonth("");
    setYear("");
    setPage(0);
  };

  const filteredData = useMemo(() => {
    return data
      .filter((row) => {
        if (activeTab === "Booked")
          return row.status === "Booked" || row.status === "Completed";
        if (activeTab === "Pending")
          return (
            row.status === "Pending" ||
            row.status === "Payment Pending" ||
            row.status === "Paid"
          );
        return row.status === activeTab;
      })
      .filter((row) => {
        const q = search.toLowerCase();
        return (
          row.domain_name?.toLowerCase().includes(q) ||
          row.institute_name?.toLowerCase().includes(q) ||
          row.trainer_name?.toLowerCase().includes(q) ||
          row.trainer_email?.toLowerCase().includes(q)
        );
      })
      .filter((row) => {
        const d = new Date(row.start_date);
        if (month !== "" && d.getMonth() !== Number(month)) return false;
        if (year !== "" && d.getFullYear() !== Number(year)) return false;
        return true;
      });
  }, [data, activeTab, search, month, year]);

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  /* ============================================================
     RENDER
     ============================================================ */

  // Check if all visible rows are tech_camp type to determine if we should hide Membership column
  const shouldHideMembershipColumn = filteredData.length > 0 &&
    filteredData.every(row => row.event_type?.toLowerCase() === "tech_camp");

  return (
    <>
      {/* ---------------- STATUS TABS ---------------- */}
      <Tabs
        value={activeTab}
        onChange={(_, value) => {
          setActiveTab(value);
          setPage(0);
          resetFilters();
        }}
        sx={{ mb: 2 }}
      >
        {STATUS_TABS.map((tab) => (
          <Tab
            key={tab}
            value={tab}
            label={
              <Box display="flex" alignItems="center" gap={0.5}>
                {tab}
                <Tooltip title={TAB_INFO[tab]} arrow>
                  <InfoOutlined fontSize="small" />
                </Tooltip>
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* ---------------- FILTER BAR ---------------- */}
      <Paper sx={{ p: 2, mb: 2, borderRadius: 3 }}>
        <Box display="flex" gap={2} flexWrap="wrap">
          <TextField
            placeholder="Search Domain / Institute / Trainer"
            size="small"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(0);
            }}
            sx={{ minWidth: 265 }}
          />
          <TextField
            select
            label="Month"
            size="small"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
              setPage(0);
            }}
            sx={{ minWidth: 140 }}
          >
            <MenuItem value="">All</MenuItem>
            {MONTHS.map((m, i) => (
              <MenuItem key={m} value={i}>
                {m}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Year"
            size="small"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
              setPage(0);
            }}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="">All</MenuItem>
            {yearOptions.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="outlined"
            color="secondary"
            onClick={resetFilters}
            sx={{ height: 40 }}
            disabled={!search && !month && !year}
          >
            Clear Filters
          </Button>
        </Box>
      </Paper>

      {/* ---------------- TABLE ---------------- */}
      <Paper
        sx={{
          borderRadius: 3,
          border: "1px solid #e5e7eb",
          position: "relative",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f8fafc" }}>
              <TableCell>
                <b>Domain</b>
              </TableCell>
              <TableCell>
                <b>Institute</b>
              </TableCell>
              <TableCell>
                <b>Date Range</b>
              </TableCell>
              {activeTab !== "Pending" && (
                <TableCell>
                  <b>Trainer</b>
                </TableCell>
              )}
              {!shouldHideMembershipColumn && (
                <TableCell>
                  <b>Membership</b>
                </TableCell>
              )}
              <TableCell>
                <b>Status</b>
              </TableCell>
              {activeTab === "Cancelled" && (
                <TableCell>
                  <b>Reason</b>
                </TableCell>
              )}
              {activeTab === "Pending" && (
                <TableCell align="center">
                  <b>Action</b>
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.interest_id} hover>
                  <TableCell>{row.domain_name}</TableCell>
                  <TableCell>{row.institute_name}</TableCell>
                  <TableCell>
                    {formatDate(row.start_date)} – {formatDate(row.end_date)}
                  </TableCell>
                  {activeTab !== "Pending" && (
                    <TableCell>
                      <Typography fontWeight={500}>{row.trainer_name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {row.trainer_email}
                      </Typography>
                    </TableCell>
                  )}
                  {!shouldHideMembershipColumn && (
                    <TableCell>
                      <Chip
                        icon={<VisibilityOutlinedIcon />}
                        label="View"
                        variant="outlined"
                        size="small"
                        clickable
                        onClick={() => openMembership(row)}
                      />
                    </TableCell>
                  )}
                  <TableCell>
                    <Chip
                      size="small"
                      label={row.status}
                      color={statusColor[row.status] ?? "default"}
                    />
                  </TableCell>
                  {activeTab === "Cancelled" && (
                    <TableCell sx={{ maxWidth: 150 }}>
                      {row.reason ? (
                        <Tooltip title={row.reason} arrow placement="top">
                          <Typography
                            variant="body2"
                            sx={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              cursor: "pointer",
                            }}
                          >
                            {row.reason}
                          </Typography>
                        </Tooltip>
                      ) : (
                        "—"
                      )}
                    </TableCell>
                  )}
                  {activeTab === "Pending" && (
                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={(e) => handleMenuOpen(e, row)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}

            {filteredData.length === 0 && (
              <TableRow>
                <TableCell
                  colSpan={activeTab === "Pending" || activeTab === "Cancelled" ? 7 : 6}
                  align="center"
                  sx={{ py: 4 }}
                >
                  No records found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />

        {actionLoading && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              bgcolor: "rgba(255,255,255,0.6)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Paper>

      {/* ---------------- ACTION MENU ---------------- */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* ✅ Book Slot — FREE: show when status is "Pending" and payment is "free"
                      — PAID: show ONLY when payment is confirmed (NOT "Pending" / NOT "Payment Pending") */}
        {(
          // FREE flow: Pending + free → show Book Slot immediately
          (menuRow?.status === "Pending" && menuRow?.payment?.toLowerCase() === "free") ||

          // status is "Paid" and payment is "free"
          (menuRow?.status === "Paid" && menuRow?.payment?.toLowerCase() === "free") ||

          // PAID flow: payment is "paid" AND status is confirmed (i.e. not "Pending" and not "Payment Pending")
          (menuRow?.payment?.toLowerCase() === "paid" &&
            menuRow?.status !== "Pending" &&
            menuRow?.status !== "Payment Pending")
        ) && (
            <MenuItem onClick={() => openBookDialog(menuRow)}>
              <ListItemIcon>
                <BookmarkAddOutlinedIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Book Slot" />
            </MenuItem>
          )}

        {/* ✅ Approve for Payment — PAID only, when status is still "Pending" */}
        {menuRow?.status === "Pending" &&
          menuRow?.payment?.toLowerCase() !== "free" && (
            <MenuItem onClick={() => approveForPayment(menuRow?.interest_id, menuRow?.event_type)}>
              <ListItemIcon>
                <CheckCircleIcon color="success" />
              </ListItemIcon>
              <ListItemText primary="Approve for Payment" />
            </MenuItem>
          )}

        {/* ✅ Cancel — always visible in Pending tab */}
        <MenuItem onClick={() => openCancelDialog(menuRow)}>
          <ListItemIcon>
            <CancelOutlinedIcon color="error" />
          </ListItemIcon>
          <ListItemText primary="Cancel" />
        </MenuItem>
      </Menu>

      {/* ---------------- MEMBERSHIP DIALOG ---------------- */}
      <Dialog
        open={membershipOpen}
        onClose={closeMembership}
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
      >
        <DialogTitle fontWeight={700}>Membership Details</DialogTitle>
        <DialogContent dividers>
          {selectedMembership && (
            <>
              <Typography
                fontWeight={600}
                gutterBottom
                sx={{
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                  lineHeight: 1.4,
                }}
              >
                {selectedMembership.membership_name}
              </Typography>
              <Typography variant="body2">
                Host:{" "}
                {selectedMembership?.fdp_limits?.host_limit ? (
                  <>
                    {selectedMembership.fdp_limits.host_limit.used} /{" "}
                    {selectedMembership.fdp_limits.host_limit.total} (Left:{" "}
                    {selectedMembership.fdp_limits.host_limit.left})
                  </>
                ) : (
                  "Not Available"
                )}
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Educators:{" "}
                {selectedMembership?.fdp_limits?.educators_limit ? (
                  <>
                    {selectedMembership.fdp_limits.educators_limit.used} /{" "}
                    {selectedMembership.fdp_limits.educators_limit.total} (Left:{" "}
                    {selectedMembership.fdp_limits.educators_limit.left})
                  </>
                ) : (
                  "Not Available"
                )}
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={closeMembership}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ============================================================
          BOOK SLOT DIALOG
          ============================================================ */}
      <Dialog
        open={bookDialogOpen}
        onClose={closeBookDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle fontWeight={700} sx={{ pb: 1 }}>
          Book Slot
          {bookingRow?.event_type && (
            <Chip
              label={bookingRow.event_type.toUpperCase()}
              size="small"
              color={isFdp ? "primary" : "secondary"}
              sx={{ ml: 1.5, fontWeight: 700, fontSize: "0.7rem" }}
            />
          )}
        </DialogTitle>

        <DialogContent dividers>
          {bookingRow && (
            <>
              {/* ── Interest Summary ── */}
              <Paper
                variant="outlined"
                sx={{ p: 2, borderRadius: 2, mb: 3, bgcolor: "#f8fafc" }}
              >
                <Box display="flex" justifyContent="space-between" alignItems="flex-end" flexWrap="wrap" gap={2}>
                  <Box flex={1} minWidth={250}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                    >
                      Interest Details
                    </Typography>
                    <Stack spacing={0.5}>
                      {[
                        ["Domain", bookingRow.domain_name],
                        ["Trainer", displayTrainerName],
                        [
                          "Dates",
                          `${formatDate(bookingRow.start_date)} – ${formatDate(bookingRow.end_date)}`,
                        ],
                        ["Institute", bookingRow.institute_name],
                      ].map(([label, value]) => (
                        <Box key={label} display="flex" gap={1}>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ minWidth: 90 }}
                          >
                            {label}
                          </Typography>
                          <Typography variant="body2" fontWeight={600}>
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                  </Box>

                  {/* Assign Trainer Dropdown on the right side */}
                  <Box sx={{ minWidth: 200, flex: 1 }}>
                    {loadingTrainers ? (
                      <Box display="flex" alignItems="center" gap={1} py={2}>
                        <CircularProgress size={16} />
                        <Typography variant="caption" color="text.secondary">Loading trainers...</Typography>
                      </Box>
                    ) : (
                      availableTrainers.length > 0 && (
                        <TextField
                          select
                          label="Assign Trainer *"
                          name="trainer_id"
                          value={form.trainer_id || ""}
                          onChange={handleFormChange}
                          error={!!errors.trainer_id}
                          helperText={errors.trainer_id}
                          size="small"
                          fullWidth
                          sx={{ mt: 1 }}
                        >
                          <MenuItem value="">Select Trainer</MenuItem>
                          {availableTrainers.map((t) => (
                            <MenuItem key={t.trainer_id} value={t.trainer_id.toString()}>
                              {t.fullname}
                            </MenuItem>
                          ))}
                        </TextField>
                      )
                    )}
                  </Box>
                </Box>
              </Paper>

              <Stack spacing={2.5}>
                {/* ── 6. Edition Number (both) ── */}
                {/* <TextField
                  label="Edition No *"
                  name="edition_no"
                  type="number"
                  size="small"
                  fullWidth
                  value={form.edition_no}
                  onChange={handleFormChange}
                  error={!!errors.edition_no}
                  helperText={errors.edition_no}
                  inputProps={{ min: 1 }}
                /> */}

                {/* ── FDP only ── */}
                {isFdp && (
                  <TextField
                    label="Total Faculty Limit *"
                    name="total_faculty_limit"
                    type="number"
                    size="small"
                    fullWidth
                    value={form.total_faculty_limit}
                    onChange={handleFormChange}
                    error={!!errors.total_faculty_limit}
                    helperText={errors.total_faculty_limit}
                    inputProps={{ min: 1 }}
                  />
                )}

                {/* ── Tech Camp only ── */}
                {isTechCamp && (
                  <TextField
                    label="Student Limit *"
                    name="students_limit"
                    type="number"
                    size="small"
                    fullWidth
                    value={form.students_limit}
                    onChange={handleFormChange}
                    error={!!errors.students_limit}
                    helperText={errors.students_limit}
                    inputProps={{ min: 1 }}
                  />
                )}

                {/* ── Slot Type (both FDP and Tech Camp) ── */}
                <FormControl error={!!errors.slot_type} component="fieldset">
                  <FormLabel
                    sx={{
                      fontSize: "0.85rem",
                      fontWeight: 500,
                      color: "text.primary",
                    }}
                  >
                    Slot Type *
                  </FormLabel>
                  <RadioGroup
                    row
                    name="slot_type"
                    value={form.slot_type || "paid"}
                    onChange={handleFormChange}
                  >
                    <FormControlLabel
                      value="paid"
                      control={<Radio size="small" />}
                      label="Paid"
                    />
                    <FormControlLabel
                      value="csr"
                      control={<Radio size="small" />}
                      label="CSR"
                    />
                    <FormControlLabel
                      value="coe"
                      control={<Radio size="small" />}
                      label="COE"
                    />
                  </RadioGroup>
                  {errors.slot_type && (
                    <FormHelperText>{errors.slot_type}</FormHelperText>
                  )}
                </FormControl>

                {/* ── Coordinator Details Divider ── */}
                <Divider>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={600}
                  >
                    Coordinator Details
                  </Typography>
                </Divider>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    Coordinators ({form.coordinators.length}/3)
                  </Typography>
                  {form.coordinators.length < 3 && (
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={handleAddCoordinator}
                      sx={{
                        textTransform: "none",
                        borderRadius: 1.5,
                        fontSize: "0.8rem",
                        fontWeight: 600,
                        py: 0.5,
                        px: 1.5,
                      }}
                    >
                      Add Coordinator
                    </Button>
                  )}
                </Box>

                {/* ── Coordinator Cards ── */}
                {form.coordinators.map((coord, idx) => {
                  const coordError = errors.coordinators?.[idx] || {};
                  return (
                    <Box
                      key={idx}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor:
                          idx === 0 ? "rgba(79, 70, 229, 0.2)" : "divider",
                        bgcolor:
                          idx === 0 ? "rgba(79, 70, 229, 0.02)" : "#f8fafc",
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.75,
                      }}
                    >
                      {form.coordinators.length > 1 && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: 600, color: "text.secondary" }}
                          >
                            Coordinator {idx + 1}
                          </Typography>
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleRemoveCoordinator(idx)}
                            title="Remove Coordinator"
                            sx={{ p: 0.5 }}
                          >
                            <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Box>
                      )}

                      {/* Name */}
                      <TextField
                        label={`Coordinator ${idx + 1} Name *`}
                        size="small"
                        fullWidth
                        value={coord.name}
                        onChange={(e) =>
                          handleCoordinatorChange(idx, "name", e.target.value)
                        }
                        error={!!coordError.name}
                        helperText={coordError.name}
                      />

                      {/* Mobile & Email in responsive row */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          flexDirection: { xs: "column", sm: "row" },
                        }}
                      >
                        <TextField
                          label="Mobile Number *"
                          size="small"
                          fullWidth
                          value={coord.mobile}
                          onChange={(e) =>
                            handleCoordinatorChange(idx, "mobile", e.target.value)
                          }
                          error={!!coordError.mobile}
                          helperText={coordError.mobile}
                          inputProps={{ maxLength: 10 }}
                        />
                        <TextField
                          label="Email *"
                          type="email"
                          size="small"
                          fullWidth
                          value={coord.email}
                          onChange={(e) =>
                            handleCoordinatorChange(idx, "email", e.target.value)
                          }
                          error={!!coordError.email}
                          helperText={coordError.email}
                        />
                      </Box>

                      {/* Gender */}
                      <FormControl error={!!coordError.gender}>
                        <FormLabel
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: 500,
                            color: "text.primary",
                            mb: 0.25,
                          }}
                        >
                          Gender *
                        </FormLabel>
                        <RadioGroup
                          row
                          value={coord.gender}
                          onChange={(e) =>
                            handleCoordinatorChange(idx, "gender", e.target.value)
                          }
                        >
                          <FormControlLabel
                            value="Male"
                            control={<Radio size="small" />}
                            label="Male"
                          />
                          <FormControlLabel
                            value="Female"
                            control={<Radio size="small" />}
                            label="Female"
                          />
                          <FormControlLabel
                            value="Other"
                            control={<Radio size="small" />}
                            label="Other"
                          />
                        </RadioGroup>
                        {coordError.gender && (
                          <FormHelperText>{coordError.gender}</FormHelperText>
                        )}
                      </FormControl>
                    </Box>
                  );
                })}

                {/* ── 13. Payment Type Display (Tech Camp only) ── */}
                {isTechCamp && (
                  <Box sx={{ mb: 1 }}>
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        fontWeight: 500,
                        color: "text.primary",
                        mb: 0.75,
                      }}
                    >
                      Payment Type
                    </Typography>
                    <Chip
                      label={form.is_paid === "free" ? "Free" : "Paid"}
                      size="small"
                      sx={{
                        backgroundColor:
                          form.is_paid === "free" ? "#10B981" : "#F59E0B",
                        color: "white",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        height: "24px",
                      }}
                    />
                  </Box>
                )}

                <Divider>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={600}
                  >
                    Hosted Institute Logo
                  </Typography>
                </Divider>

                {/* ── 13. Image Upload ── */}
                <Box>
                  <input
                    ref={imageInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <Button
                    variant="outlined"
                    startIcon={<UploadFileOutlinedIcon />}
                    onClick={() => imageInputRef.current.click()}
                    fullWidth
                    color={errors.image ? "error" : "primary"}
                    sx={{
                      textTransform: "none",
                      borderRadius: 2,
                      justifyContent: "flex-start",
                      px: 2,
                    }}
                  >
                    {imageFile
                      ? imageFile.name
                      : "Upload Hosted Institute Logo *"}
                  </Button>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ mt: 0.5, display: "block" }}
                  >
                    Accepted formats: JPG, PNG, WEBP &nbsp;|&nbsp; Max size: 500
                    KB
                  </Typography>
                  {errors.image && (
                    <FormHelperText error sx={{ ml: 0 }}>
                      {errors.image}
                    </FormHelperText>
                  )}

                  {/* Image preview */}
                  {imagePreview && (
                    <Box
                      mt={1.5}
                      sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                        overflow: "hidden",
                        width: "100%",
                        maxHeight: 140,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "#f8fafc",
                      }}
                    >
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{
                          maxHeight: 140,
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  )}
                </Box>

                {bookError && (
                  <Alert severity="error" sx={{ borderRadius: 2 }}>
                    {bookError}
                  </Alert>
                )}
              </Stack>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={closeBookDialog}
            disabled={bookLoading}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleBookSubmit}
            disabled={bookLoading}
            startIcon={
              bookLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <BookmarkAddOutlinedIcon />
              )
            }
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            {bookLoading ? "Booking..." : "Confirm Booking"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ============================================================
          CANCEL DIALOG
          ============================================================ */}
      <Dialog
        open={cancelDialogOpen}
        onClose={closeCancelDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle fontWeight={700}>Cancel Interest</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Please provide a reason for cancelling this interest.
          </Typography>
          <TextField
            label="Reason *"
            multiline
            rows={3}
            fullWidth
            value={cancelReason}
            onChange={(e) => {
              setCancelReason(e.target.value);
              if (e.target.value.trim()) setCancelError("");
            }}
            error={!!cancelError}
            helperText={cancelError}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={closeCancelDialog} disabled={actionLoading} sx={{ textTransform: "none" }}>
            Close
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={submitCancelInterest}
            disabled={actionLoading}
            startIcon={
              actionLoading ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <CancelOutlinedIcon />
              )
            }
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            {actionLoading ? "Cancelling..." : "Confirm Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FDPInterestsTable;